import { useState } from 'react';

export enum NotifyCommentFields {
  comment,
  notifyMailroom,
  skipNotifyRecipient,
}

export type NotifyCommentValuesType = {
  comment: string;
  notifyMailroom: boolean;
  skipNotifyRecipient: boolean;
};

export type NotifyCommentOnChangeType = (field: NotifyCommentFields, value: string | boolean) => void;

const useNotifyComment = (): { values: NotifyCommentValuesType; changeValues: NotifyCommentOnChangeType, resetValues: () => void } => {
  const [comment, setComment] = useState('');
  const [notifyMailroom, setNotifyMailroom] = useState(true);
  const [skipNotifyRecipient, setSkipNotifyRecipient] = useState(false);

  const onChange: NotifyCommentOnChangeType = (field, value) => {
    switch (field) {
      case NotifyCommentFields.comment:
        setComment(value.toString());
        break;

      case NotifyCommentFields.notifyMailroom:
        setNotifyMailroom(!!value);
        break;

      case NotifyCommentFields.skipNotifyRecipient:
        setSkipNotifyRecipient(!!value);
        break;

      default:
        break;
    }
  };

  const reset = () => {
    setComment('');
    setNotifyMailroom(true);
    setSkipNotifyRecipient(false);
  }

  return {
    values: { comment, notifyMailroom, skipNotifyRecipient },
    changeValues: onChange,
    resetValues: reset,
  };
};

export default useNotifyComment;
